/**
 * Static-translations for pt. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const pt = {
  'anon.description_default': 'Configurando sua sessão de convidado…',
  'anon.heading_default': 'Continuar como convidado',
  'anon.try_again': 'Tentar novamente',
  'auth.back_to_login': 'Voltar ao login',
  'auth.check_email_message': 'Verifique seu e-mail para o código de confirmação.',
  'auth.check_email_title': 'Verifique seu e-mail',
  'auth.confirm_email_subtitle': 'Digite o código que enviamos para seu e-mail para concluir o cadastro.',
  'auth.confirm_email_title': 'Confirme seu e-mail',
  'auth.confirmation_code': 'Código de confirmação',
  'auth.continue_with_apple': 'Continuar com Apple',
  'auth.continue_with_facebook': 'Continuar com Facebook',
  'auth.continue_with_github': 'Continuar com GitHub',
  'auth.continue_with_google': 'Continuar com Google',
  'auth.create_account': 'Criar conta',
  'auth.default_subtitle': 'Faça login para acessar todos os recursos e sincronizar seus dados.',
  'auth.email': 'Endereço de e-mail',
  'auth.email_already_registered': 'Este e-mail já está registrado. Entre abaixo com sua senha ou a conta que você usou para se cadastrar.',
  'auth.email_exists': 'Já existe uma conta com este e-mail.',
  'auth.email_not_confirmed': 'Por favor, confirme seu e-mail primeiro.',
  'auth.forgot_password': 'Esqueceu sua senha?',
  'auth.forgot_password_title': 'Esqueceu sua senha?',
  'auth.forgot_subtitle': 'Digite seu e-mail e enviaremos um link para redefinir sua senha.',
  'auth.generic_error': 'Algo deu errado',
  'auth.have_account': 'Tem uma conta?',
  'auth.hide_password': 'Ocultar senha',
  'auth.identity_already_linked': 'Esta conta já está registrada. Entre com ela abaixo.',
  'auth.invalid_credentials': 'E-mail ou senha inválidos',
  'auth.invalid_otp': 'O código é inválido ou expirou.',
  'auth.last_used': 'Última vez · {email}',
  'auth.last_used_no_email': 'Última vez',
  'auth.link_purchase_subheading': 'Vincularemos a compra à sua conta para manter o acesso.',
  'auth.log_in': 'Fazer Login',
  'auth.log_in_link': 'Fazer Login',
  'auth.login_continue_purchase': 'Faça login para continuar sua compra',
  'auth.network_error': 'Erro de rede. Verifique sua conexão e tente novamente.',
  'auth.new_password_optional': 'Nova senha (opcional — somente para redefinição)',
  'auth.no_account': 'Não tem uma conta?',
  'auth.or': 'ou',
  'auth.password': 'Senha',
  'auth.passwords_mismatch': 'As senhas não correspondem',
  'auth.rate_limited': 'Muitas solicitações. Tente novamente mais tarde.',
  'auth.repeat_password': 'Repetir senha',
  'auth.reset_link_valid': 'O link é válido por 1 hora.',
  'auth.reset_password_subtitle': 'Digite o código do seu e-mail e uma nova senha.',
  'auth.reset_password_title': 'Redefinir senha',
  'auth.reset_sent_message': 'Se esse e-mail existir, um código de redefinição foi enviado.',
  'auth.reset_sent_subtitle': 'Enviamos um link para redefinir sua senha. Siga as instruções no e-mail.',
  'auth.restore_purchases_heading': 'Restaurar Compras',
  'auth.restore_purchases_subheading': 'Por favor, faça login para restaurar suas compras.',
  'auth.send_reset': 'Enviar E-mail de Redefinição',
  'auth.service_unavailable': 'Serviço temporariamente indisponível. Tente novamente mais tarde.',
  'auth.show_password': 'Mostrar senha',
  'auth.sign_out': 'Sair',
  'auth.sign_up': 'Cadastrar-se',
  'auth.sign_up_link': 'Cadastrar-se',
  'auth.signed_in': 'Conectado',
  'auth.signin_failed': 'Falha no login',
  'auth.signup_failed': 'Falha no cadastro',
  'auth.verify': 'Verificar',
  'auth.weak_password': 'A senha é muito fraca.',
  'auth.welcome': 'Bem-vindo!',
  'auth.welcome_signup': 'Bem-vindo!',
  'cta.close': 'Fechar',
  'cta.continue': 'Continuar',
  'cta.get_lifetime_access': 'Obter acesso vitalício',
  'cta.get_plan_daily': 'Obter plano diário',
  'cta.get_plan_generic': 'Obter plano {interval}',
  'cta.get_plan_monthly': 'Obter plano mensal',
  'cta.get_plan_weekly': 'Obter plano semanal',
  'cta.get_plan_yearly': 'Obter plano anual',
  'cta.start_trial': 'Iniciar Teste Gratuito de {days} Dias',
  'modal.close_aria': 'Fechar',
  'modal.continue': 'Continuar',
  'modal.error_generic': 'Algo deu errado',
  'modal.loading': 'Carregando…',
  'modal.purchase_restored_subtitle': 'Tudo pronto — aproveite!',
  'modal.purchase_restored_title': 'Bem-vindo de volta',
  'modal.purchase_success_subtitle': 'Tudo pronto — aproveite!',
  'modal.purchase_success_title': 'Pagamento recebido',
  'modal.verifying_subscription': 'Verificando sua assinatura…',
  'nav.back': '← Voltar',
  'nav.back_aria': 'Voltar',
  'offer.limited_time': 'Oferta por tempo limitado',
  'payment.awaiting_subtitle': 'Detectaremos seu pagamento automaticamente — ou clique abaixo quando terminar.',
  'payment.awaiting_title': 'Conclua o pagamento na nova aba',
  'payment.checking': 'Verificando…',
  'payment.ive_paid': 'Eu paguei',
  'payment.open_checkout_again': 'Abrir checkout novamente',
  'payment.open_checkout_button': 'Abrir checkout',
  'payment.popup_blocked_message': 'Seu navegador bloqueou a aba de checkout. Clique abaixo para abri-la.',
  'payment.popup_blocked_title': 'Permita pop-ups para continuar',
  'payment.popup_help_text': 'A janela de checkout não abriu ou foi bloqueada? Clique aqui para abri-la novamente.',
  'payment.still_processing': 'O pagamento ainda está sendo processado. Tente novamente em um momento.',
  'payment.tab_closed_retry': 'Aba fechada? Tente novamente',
  'pricing.free_trial_days': 'Teste grátis de {days} dias',
  'pricing.included_per': 'Incluído por {interval}:',
  'pricing.interval.day': 'dia',
  'pricing.interval.lifetime_short': 'vitalício',
  'pricing.interval.month': 'mês',
  'pricing.interval.period': 'período',
  'pricing.interval.week': 'semana',
  'pricing.interval.year': 'ano',
  'pricing.money_back': 'Garantia de reembolso de 30 dias',
  'pricing.most_popular': 'Mais popular',
  'pricing.no_prices': 'Nenhum preço disponível.',
  'pricing.plan_label.daily': 'PLANO DIÁRIO',
  'pricing.plan_label.lifetime': 'vitalício',
  'pricing.plan_label.monthly': 'plano mensal',
  'pricing.plan_label.weekly': 'plano semanal',
  'pricing.plan_label.yearly': 'plano anual',
  'pricing.plans_aria': 'Planos',
  'session.contact_support': 'Contatar suporte',
  'session.restore_purchases': 'Restaurar compras',
  'session.sign_out': 'Sair',
  'session.signed_in_as_prefix': 'Conectado como',
  'session.signing_out': 'Saindo…',
  'support.attachments_aria': 'Upload de anexos',
  'support.attachments_label': 'Anexos',
  'support.close_button': 'Fechar',
  'support.done_button': 'Concluído',
  'support.dropzone_text': 'Solte imagens aqui ou clique para selecionar',
  'support.email_placeholder': 'Digite seu e-mail',
  'support.file_requirements': 'JPEG/PNG/WebP, até {max} arquivos, ≤ {size} MB cada',
  'support.heading': 'Suporte',
  'support.instruction': 'Por favor, preencha o formulário abaixo para enviar sua solicitação de suporte.',
  'support.invalid_email': 'E-mail inválido',
  'support.invalid_file': 'Apenas JPEG/PNG/WebP, ≤ {size} MB cada',
  'support.message_length': '1–5000 caracteres',
  'support.message_placeholder': 'Digite sua mensagem',
  'support.remove_file_aria': 'Remover {filename}',
  'support.required': 'Obrigatório',
  'support.send_another': 'Enviar outra solicitação',
  'support.send_button': 'Enviar',
  'support.sending': 'Enviando…',
  'support.sending_as': 'Enviando como',
  'support.subject_length': '3–200 caracteres',
  'support.subject_placeholder': 'Digite o assunto',
  'support.success_heading': 'Solicitação enviada',
  'support.success_message_prefix': 'Recebemos sua mensagem e responderemos para',
  'support.too_many_files': 'Até {max} arquivos'
} as const;

export default pt;
